<template>
  <div>
    <div class="maxbox">
      <div>
        <div class="top">
          <p>我的社区</p>
        </div>
        <div class="main">
          <button class="return" @click="goback">
            <img src="@/assets/images/left-arrow.png" alt="" />
          </button><br>

          <div class="number">
            <p class="inline-info">
              <span>我的推荐人：{{ referrerShowAddr || '暂无' }}</span>
            </p>
            <p class="inline-info" style="margin-top: 8px;">
              <span id="directReferrals">我的直接推荐人数: {{ directReferrals }}</span>
            </p>
            <p class="inline-info" style="margin-top: 8px;">
              <span>我的10代团队总人数: {{ loadingTeam ? '计算中…' : teamTotal }}</span>
            </p>
          </div><br>

          <div class="referrals-container">
            <div v-for="(addr, index) in directReferralList" :key="index" class="pyuser">
              <img src="@/assets/images/pyusers.png" alt="" />
              <p>{{ formatAddress(addr) }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
 /* eslint-disable */ 
import { ethers } from "ethers";
import { contractAddress, contractABI } from "@/js/contract.js";

// 子图查询地址
const SUBGRAPH_URL = "https://gateway.thegraph.com/api/subgraphs/id/C95kzECu3rd3igQsGfTW6hN11Tw37hp9RyDsVdiMmpGx";

export default {
  name: "myteam",
  data() {
    return {
      referrerAddr: "",        // 原始推荐人地址
      referrerShowAddr: "",    // 缩写展示地址
      directReferrals: 0,      // 直推人数
      teamTotal: 0,            // 10代团队总人数（从子图获取）
      directReferralList: [],  // 直推列表
      contract: null,
      loadingTeam: false       // 防抖标记，防止重复请求
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async getContract() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      this.contract = new ethers.Contract(contractAddress, contractABI, signer);
      return this.contract;
    },

    // 获取自己的上级推荐人
    async getMyReferrer() {
      try {
        const c = await this.getContract();
        const addr = await c.getMyDirectReferrer();
        this.referrerAddr = addr;
        if(addr === ethers.constants.AddressZero){
          this.referrerShowAddr = "";
        }else{
          this.referrerShowAddr = this.formatAddress(addr);
        }
      } catch (e) {
        console.error("获取推荐人失败", e);
      }
    },

    // 获取直推列表+直推人数
    async getDirectData() {
      try {
        const c = await this.getContract();
        const list = await c.getMyDirectReferrals();
        this.directReferralList = list;
        this.directReferrals = list.length;
      } catch (e) {
        console.error("获取直推数据失败", e);
      }
    },

    // 【替换原合约BFS逻辑】从The Graph子图读取10代团队总人数
   // 【替换原合约BFS逻辑】从The Graph子图读取10代团队总人数
async getTenLevelTeamNum() {
  if(this.loadingTeam) return;
  this.loadingTeam = true;
  try {
    const c = await this.getContract();
    const myAddr = await c.signer.getAddress();
    // 地址转小写匹配子图存储规则
    const lowerAddr = myAddr.toLowerCase();
    const graphQuery = `
      query GetUserTeamCount($userId: ID!) {
        userTeamStat(id: $userId) {
          tenLevelTotalMember
        }
      }
    `;
    // 正式网关必须携带鉴权Header
    const authHeaders = {
      "Content-Type": "application/json",
      "Authorization": "Bearer 8f9c604fdd39444789841cbead617821"
    };
    const res = await fetch(SUBGRAPH_URL, {
      method: "POST",
      headers: authHeaders,
      body: JSON.stringify({
        query: graphQuery,
        variables: {
          userId: lowerAddr
        }
      })
    });
    const json = await res.json();
    // 打印完整错误，方便线上排查
    if(json.errors) {
      console.error("子图查询团队人数错误详情：", JSON.stringify(json.errors, null, 2));
    }
    // 子图无数据时置0
    if (json.data && json.data.userTeamStat) {
      this.teamTotal = Number(json.data.userTeamStat.tenLevelTotalMember);
    } else {
      this.teamTotal = 0;
    }
  } catch (e) {
    console.error("子图读取10代团队人数失败", e);
    this.teamTotal = 0;
  } finally {
    this.loadingTeam = false;
  }
},


    async fetchAllData() {
      await this.getContract();
      await this.getMyReferrer();
      await this.getDirectData();
      await this.getTenLevelTeamNum();
    },

    // 统一地址缩写方法 6位+...+4位
    formatAddress(address) {
      if (!address) return "";
      return address.slice(0, 6) + "..." + address.slice(-4);
    }
  },
  mounted() {
    if(window.ethereum){
      this.fetchAllData();
    }
  },
};
</script>

<style scoped>
@import "@/assets/css/team.css";
@import "@/assets/css/style.css";

.inline-info {
  display: flex;
  align-items: center;
  gap: 5px;
}
/* .main {
  padding-top: 50px;
  padding-bottom: 20px;
} */

.main {
  padding-top:30px;
  
  padding-bottom: 80px;
  min-height: 680px;
}
.referrals-container {
  max-height: 400px;
  overflow-y: auto;
}
.pyuser {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pyuser p {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
</style>
